import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-40" }
const _hoisted_2 = { class: "card-body p-xl-60" }
const _hoisted_3 = {
  key: 0,
  class: "row gx-xxl-6"
}
const _hoisted_4 = { class: "col-xl-4 col-lg-5 pe-xxl-1" }
const _hoisted_5 = { class: "single-product-img" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "col-xl-8 col-lg-7 ps-xxl-6" }
const _hoisted_8 = { class: "table single-product-table mb-60" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.product)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: _ctx.product.imageUrl,
                  alt: "Product"
                }, null, 8, _hoisted_6)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { scope: "col" }, "Type"),
                    _createElementVNode("th", { scope: "col" }, "Single")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _cache[0] || (_cache[0] = _createElementVNode("th", { scope: "row" }, "Product Code", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.product.barCode), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[1] || (_cache[1] = _createElementVNode("th", { scope: "row" }, "Product Name", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.product.name), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[2] || (_cache[2] = _createElementVNode("th", { scope: "row" }, "Category", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.product.categoryName), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[3] || (_cache[3] = _createElementVNode("th", { scope: "row" }, "Brand", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.product.brand), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[4] || (_cache[4] = _createElementVNode("th", { scope: "row" }, "Price", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.product.price), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[5] || (_cache[5] = _createElementVNode("th", { scope: "row" }, "Product Quantity", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.product.quantity), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[6] || (_cache[6] = _createElementVNode("th", { scope: "row" }, "Stock Alert", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.product.minimumReorderQuantity), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[7] || (_cache[7] = _createElementVNode("th", { scope: "row" }, "Expiry Date", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.product.expiredDate), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[8] || (_cache[8] = _createElementVNode("th", { scope: "row" }, "Notes", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.product.description), 1)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}